import axios from "axios";

// Κενό REACT_APP_BACKEND_URL = same-origin deployment (nginx proxy στο /api)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// ─── Auto-refresh: σε 401 δοκιμάζει /auth/refresh μία φορά και επαναλαμβάνει ──
const AUTH_PATHS = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout", "/auth/login/2fa"];
let refreshPromise = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status = error?.response?.status;
    const isAuthPath = AUTH_PATHS.some((p) => original?.url?.includes(p));
    if (status !== 401 || isAuthPath || original?._retried) {
      return Promise.reject(error);
    }
    original._retried = true;
    try {
      // single-flight: πολλά 401 ταυτόχρονα → ένα μόνο refresh request
      if (!refreshPromise) {
        refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
      }
      await refreshPromise;
      return api(original);
    } catch (_e) {
      return Promise.reject(error);
    }
  }
);

export function formatError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Σφάλμα δικτύου";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(e => (e?.msg ?? JSON.stringify(e))).join(" ");
  return String(d);
}
